// extracted by mini-css-extract-plugin
export default {"marquee":"AutoPlayCarousle_marquee__y-t88","track":"AutoPlayCarousle_track__-9R5G","item":"AutoPlayCarousle_item__o2vLf","dot":"AutoPlayCarousle_dot__QYkHB"};